import React from 'react';
import { Modal } from 'reactstrap';
import { X } from 'react-feather';
import { cx } from './cx';

interface DialogProps {
  open?: boolean;
  /** Alias used by many call sites; same as `open`. */
  isOpen?: boolean;
  onClose: () => void;
  title: React.ReactNode;
  /** Buttons, right aligned. The main action goes last. */
  actions?: React.ReactNode;
  /** md (default) for forms and confirms, lg/xl for tables. */
  size?: 'md' | 'lg' | 'xl';
  /** For forms with unsaved input: backdrop clicks and Esc don't close it (the close button and actions still do). */
  persistent?: boolean;
  className?: string;
  children?: React.ReactNode;
}

/** Modal for content and forms. For a yes/no question use useConfirm instead. */
const Dialog: React.FC<DialogProps> = ({
  open,
  isOpen,
  onClose,
  title,
  actions,
  size = 'md',
  persistent,
  className,
  children,
}) => (
  <Modal
    isOpen={open ?? isOpen ?? false}
    toggle={onClose}
    centered
    size={size === 'md' ? undefined : size}
    className={cx('ds-dialog', size !== 'md' && 'ds-dialog--wide', size === 'xl' && 'ds-dialog--xl', className)}
    contentClassName="ds-dialog__content"
    backdrop={persistent ? 'static' : true}
    keyboard={!persistent}
    returnFocusAfterClose
  >
    <div className="ds-dialog__head">
      <h2 className="ds-dialog__title">{title}</h2>
      <button type="button" className="ds-dialog__close" onClick={onClose} aria-label="Close">
        <X size={18} aria-hidden />
      </button>
    </div>
    <div className="ds-dialog__body">{children}</div>
    {actions && <div className="ds-dialog__actions">{actions}</div>}
  </Modal>
);

export default Dialog;
